<template>
  <el-dialog :visible.sync="visible" class="elDialog" :title="!dataForm.id ? $t('add') : $t('update')" :close-on-click-modal="false" :close-on-press-escape="false">
    <el-form :model="dataForm" style="padding-right: 40px;" :rules="dataRule" ref="dataForm" @keyup.enter.native="dataFormSubmitHandle()" label-width="80px">
      <el-form-item prop="name" :label="$t('role.name')">
        <el-input v-model="dataForm.name" :placeholder="$t('role.name')"></el-input>
      </el-form-item>
      <!-- <el-form-item prop="bodyIds" label="税源地">
        <el-select v-model="dataForm.bodyIds" placeholder="请选择" style="width:100%" multiple >
          <el-option
            v-for="item in bodyPageList"
            :key="item.id"
            :label="item.bodyName"
            :value="item.id">
          </el-option>
        </el-select>
      </el-form-item> -->
      <el-form-item prop="remark" :label="$t('role.remark')">
        <el-input v-model="dataForm.remark" :placeholder="$t('role.remark')"></el-input>
      </el-form-item>
      <el-row>
        <el-col :span="12">
          <el-form-item size="mini" :label="$t('role.menuList')">
            <el-tree
              :check-strictly="isCheckStrictly"
              :data="menuList"
              :props="{ label: 'name', children: 'children' }"
              node-key="id"
              ref="menuListTree"
              accordion
              show-checkbox>
            </el-tree>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <!-- <el-form-item size="mini" :label="$t('role.deptList')">
            <el-tree
              :check-strictly="isCheckStrictly"
              :data="deptList"
              :props="{ label: 'name', children: 'children' }"
              node-key="id"
              ref="deptListTree"
              accordion
              show-checkbox>
            </el-tree>
          </el-form-item> -->
          <el-form-item size="mini" label="税源地">
            <el-tree
              :check-strictly="isCheckStrictly"
              :data="bodyPageList"
              :props="{ label: 'bodyName', children: 'children' }"
              node-key="id"
              ref="deptListTree"
              accordion
              show-checkbox>
            </el-tree>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <template slot="footer">
      <el-button @click="visible = false">{{ $t('cancel') }}</el-button>
      <el-button type="primary" @click="dataFormSubmitHandle()" :loading="loadingbut">{{ $t('confirm') }}</el-button>
    </template>
  </el-dialog>
</template>

<script>
import debounce from 'lodash/debounce'
export default {
  data () {
    return {
      bodyIds:'',
      bodyPageList:[],//税源地列表
      isCheckStrictly:true,
      visible: false,
	  loadingbut: false,
      menuList: [],
      deptList: [],
      dataForm: {
        id: '',
        name: '',
        menuIdList: [],
        deptIdList: [],
        remark: '',
        // bodyIds:''
      }
    }
  },
  computed: {
    dataRule () {
      return {
        name: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        // bodyIds: [
        //   { required: true, message: this.$t('validate.required'), trigger: 'change' }
        // ]
      }
    }
  },
  methods: {
    init () {
      this.visible = true
      this.$nextTick(() => {
        this.$refs['dataForm'].resetFields()
        this.$refs.menuListTree.setCheckedKeys([])
        this.$refs.deptListTree.setCheckedKeys([])
        this.getBodyPage();
        Promise.all([
          this.getMenuList(),
          this.getDeptList()
        ]).then(() => {
          if (this.dataForm.id) {
            this.getInfo()
          }
        })
      })
    },
    // 获取菜单列表
    getMenuList () {
      return this.$http.get('/sys/menu/select').then(({ data: res }) => {
        if (res.code !== 0) {
          return this.$message.error(res.msg)
        }
        this.menuList = res.data
      }).catch(() => {})
    },
    // 获取税源地列表
    getBodyPage(){
      this.$http.get('/sys/plat/body/page?page=1&limit=1000').then(({data:res}) => {
        console.log(res)
        if(res.code !== 0){
          return this.$message.error(res.msg)
        }else{
          this.bodyPageList = res.data.list
        }
      })
    },
    // 获取部门列表
    getDeptList () {
      return this.$http.get('/sys/dept/list').then(({ data: res }) => {
        if (res.code !== 0) {
          return this.$message.error(res.msg)
        }
        this.deptList = res.data
      }).catch(() => {})
    },
    // 获取信息
    getInfo () {
      this.$http.get(`/sys/role/${this.dataForm.id}`).then(({ data: res }) => {
        if (res.code !== 0) {
          return this.$message.error(res.msg)
        }
        this.dataForm = {
          ...this.dataForm,
          ...res.data
        }
        this.dataForm.menuIdList.forEach(item => this.$refs.menuListTree.setChecked(item, true))
        // this.dataForm.bodyIds = this.dataForm.bodyIds.split(',');
        this.$refs.deptListTree.setCheckedKeys(this.dataForm.bodyIds.split(','))
      }).catch(() => {})
    },
    // 表单提交
    dataFormSubmitHandle: debounce(function () {
      console.log(this.$refs.deptListTree.getCheckedKeys().toString())
      this.$refs['dataForm'].validate((valid) => {
        if (!valid) {
          return false
        }
        this.dataForm.menuIdList = [
          ...this.$refs.menuListTree.getCheckedKeys(),
          ...this.$refs.menuListTree.getHalfCheckedKeys()
        ]
        this.dataForm.bodyIds = this.$refs.deptListTree.getCheckedKeys().toString()
        // this.dataForm.bodyIds = this.dataForm.bodyIds.toString();
        this.loadingbut = true
        this.$http[!this.dataForm.id ? 'post' : 'put']('/sys/role', this.dataForm).then(({ data: res }) => {
          this.loadingbut = false
		  if (res.code !== 0) {
            return this.$message.error(res.msg)
          }
          this.$message({
            message: this.$t('prompt.success'),
            type: 'success',
            duration: 500,
            onClose: () => {
              this.visible = false
              this.$emit('refreshDataList')
            }
          })
        // this.dataForm.bodyIds = this.dataForm.bodyIds.split(',');
        }).catch(() => {})
      })
    }, 1000, { 'leading': true, 'trailing': false })
  }
}
</script>
<style scoped="scoped">
	.elDialog >>> .el-dialog__header{
		padding: 23px 39px;
		border-bottom: 1px solid #D1D1D1;
	}
	.elDialog >>> .el-dialog__body{
		border-bottom: 1px solid #D1D1D1;
	}
</style>
